import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import deleteIcon from '../../../assests/learning-tracking/lesson/delete-icon.png'
import editIcon from '../../../assests/learning-tracking/lesson/edit-icon-highlight.png'
import useClickOutside from "../../../hooks/useClickOutside";
import * as PathRouter from '../../../models/PathRoute'
import classes from './Course.module.css';
import Card from '../../UI/Card';
import { studyGroupsApi } from "../../../utils";
import { throwApiError } from '../../lms-shared/store/error-handling-actions'
import { coursesAction } from "../../../store/course-slice";
import { onKeyDown } from "../../../service";
import DynamicMessage from "../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../lms-shared/models/DynamicMessageTypeEnum";


const Course = ({ id, courseId, color, discipline, literalYear, course, name, create, actions, getPassUrlFromCourse, pendingMessagesCount, pendingSubmissionsCount }) => {
    const texts = useSelector(state => state.translate.texts);
    const [showActionMenu, setShowActionMenu] = useState(false)
    const [nameCourse, setNameCourse] = useState(name)
    const [messagePopup, setMessagePopup] = useState()
    const homeUrl = useSelector((state) => state.application.homeUrl);
    const courses = useSelector(state => state.courses.courses);
    const dispatch = useDispatch()

    const [showEditPopup, setShowEditPopup] = useState(false)
    const actionMenuRef = useRef(null);
    const editInpurRef = useRef()
    const navigate = useNavigate();

    const goToCourseActionMenu = (e, goTo) => {
        e.stopPropagation();
        console.log("goTo", goTo)
        navigate(goTo)
    }
    const deleteCourse = (e) => {
        e.stopPropagation()
        setMessagePopup(<DynamicMessage type={DynamicMessageTypeEnum.Warn} cancelFunc={(e) => cancelDelete(e)} confirmFunc={(e) => deleteCourseConfirm(e)} content={texts.MessageContentDeleteStudyGroupWarn} />)
    }
    const deleteCourseConfirm = (e) => {
        e.stopPropagation()
        studyGroupsApi.studyGroupsDeleteIdPost(id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.studygroupDeleteError, error: error, statusCode: response?.statusCode, message: "studyGroupsDeleteIdPost " + error.message, level: 2, component: "Course", line: 42 }))
            }
            else {
                dispatch(coursesAction.remove(id));
            }
        })
        setMessagePopup(false)
    }
    const cancelDelete = (e) => {
        e?.stopPropagation()
        setMessagePopup(false)
    }
    function saveNewName(e) {
        setShowEditPopup(false)
        e.stopPropagation()
        if (name !== nameCourse && nameCourse !== '') {
            let data = {
                studyGroupId: id,
                courseId: courseId,
                name: nameCourse
            }
            studyGroupsApi.studyGroupsUpdatePost({ studyGroupUpdateInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.studygroupNameUpdateError, error: error, statusCode: response?.statusCode, message: "studyGroupsUpdatePost " + error.message, level: 2, component: "Course", line: 65 }))
                }
                else {
                    let arr = [...courses];
                    arr[arr.findIndex(c => c.id == id)] = { ...arr[arr.findIndex(c => c.id == id)], name: nameCourse };
                    dispatch(coursesAction.init(arr))
                }
            })
        }
    }
    useClickOutside(actionMenuRef, () =>
        setShowActionMenu(false)
    );

    function setEditFocus(e) {
        setShowEditPopup(true)
        e.stopPropagation()
    }

    useEffect(() => {
        if (showEditPopup)
            editInpurRef.current.focus()
    }, [showEditPopup])

    function navigateFunc() {
        if (!showEditPopup)
            create ? navigate(`${homeUrl}/${PathRouter.COURSES}/${PathRouter.NEW}`) : getPassUrlFromCourse && navigate(getPassUrlFromCourse(id))
    }

    const goToLearningTrackingMain = (e) => {
        goToCourseActionMenu(e, `${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/learningTrackingMain`);
    }

    const goToCourse = (e) => {
        goToCourseActionMenu(e, `${homeUrl}/${PathRouter.COURSES}/${id}`);
    }

    const goToViewLessons = (e) => {
        goToCourseActionMenu(e, `${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.LESSON}/0`);
    }

    const goToTeams = (e) => {
        goToCourseActionMenu(e, `${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.TEAMS}/0`);
    }

    return (
        <div className={classes.Course} onClick={navigateFunc} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, navigateFunc)}>
            {messagePopup}
            <Card>
                <div className={classes.TopPart} style={{ backgroundColor: color }} onClick={(e) => e.stopPropagation()}>
                    <div className={classes.ActionsAndIcons}>
                        <div className={classes.Icons}>
                            {pendingMessagesCount > 0 && <div className={classes.MessagesIcon}>
                                <div className={classes.RedCircle}></div>
                            </div>}
                            {pendingSubmissionsCount > 0 && <div className={classes.SubmissionsIcon}>
                                <div className={classes.RedCircle}></div>
                            </div>}
                        </div>
                        {actions && <div className={classes.Actions}>
                            <div className={classes.Dots} onClick={() => setShowActionMenu(!showActionMenu)} tabIndex="0" role="button" onKeyDown={e => { e.stopPropagation(); onKeyDown(e, () => setShowActionMenu(!showActionMenu)) }}>
                                {[...Array(3)].map((x, i) => <div className={classes.Dot} key={i}></div>)}
                            </div>
                        </div>}
                        {showActionMenu &&
                            <div ref={actionMenuRef} className={classes.ActionMenu}>
                                <div className={classes.ActionMenuText} onClick={goToLearningTrackingMain} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, goToLearningTrackingMain)}>{texts.dashboardLearningMonitoring}</div>
                                <div className={classes.ActionMenuText} onClick={goToCourse} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, goToCourse)}>{texts.editCourse}</div>
                                <div className={classes.ActionMenuText} onClick={goToViewLessons} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, goToViewLessons)}>{texts.viewLessons}</div>
                                <div className={classes.ActionMenuText} onClick={goToTeams} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, goToTeams)}>{texts.divisionIntoTeams}</div>
                                {/* <div className={classes.ActionMenuText} onClick={(e) => deleteCourse(e)}>{texts.deleteCourse}</div> */}
                            </div>
                        }
                    </div>
                </div>

                <div className={classes.Content}>
                    {showEditPopup && <div className={classes.ContentChangeName}></div>}
                    {/* WHAT discipline is for? */}
                    {/* <div className={classes.Discipline}>{discipline}</div> */}
                    {course && <div className={classes.Discipline} title={course.name}>{course.name}</div>}
                    {/* {nameCourse && */}
                    {!create && <div className={classes.NameWrapper}>
                        {showEditPopup ?
                            <input disabled={!showEditPopup} ref={editInpurRef} className={classes.Name} value={nameCourse} onChange={(e) => { setNameCourse(e.target.value) }} onClick={(e) => { e.stopPropagation() }} onBlur={saveNewName} />
                            :
                            <div className={classes.Name} title={nameCourse}>{nameCourse}</div>
                        }
                    </div>}
                    {/* } */}
                    {!create && literalYear &&
                        <div className={classes.Date}>{literalYear}</div>
                    }
                    {create &&
                        <div className={classes.Plus}>
                            <div className={`${classes.Line} ${classes.Vertical}`}></div>
                            <div className={classes.Line}></div>
                        </div>
                    }
                </div>
                {
                    !create && <div className={classes.ActionsIconsContainer}>
                        <img src={editIcon} alt="editIcon" onClick={(e) => setEditFocus(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setEditFocus(e))} />
                        <img src={deleteIcon} className={classes.DeleteIcon} alt="delete" onClick={(e) => deleteCourse(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => deleteCourse(e))} />
                    </div>
                }
            </Card >
        </div >
    )
}

Course.propTypes = {
    color: PropTypes.string,
    discipline: PropTypes.string,
    name: PropTypes.string,
    create: PropTypes.bool,
    actions: PropTypes.bool
}

export default Course;